import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Paper from "@material-ui/core/Paper";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
// import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Box from "@material-ui/core/Box";
//Screens
// import Detalles from "./ViajeDetalles";
import PrimerPaciente from "./PrimerPaciente";
import SegundoPaciente from "./SegundoPaciente";
import Confirmacion from "./Confirmacion";
import ViajeDetalles from "./ViajeDetalles";
import LoadingServicio from "./LoadingServicio";
import moment from "moment";
// import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import Swal from "sweetalert2";
import { BASE_URL } from "../../../utils/index";
import { postJson } from "../../../utils/postJson";
import { format } from "date-fns";
import TercerPaciente from "./TercerPaciente";
import CuartoPaciente from "./CuartoPaciente";
import Error from "../Error";

// import Exitoso from "../Exitoso";
// import Error from "../Error";

export default function Mutuas() {
  const isCompact = useMediaQuery("(max-width: 1221.95px)");
  const drawerWidth = 240;
  const contentMaxWidth = 950;
  const defaultProps = {
    bgcolor: "background.paper",
    m: 1,
    border: 1,
  };

  //request data

  useEffect(() => {
    const fetchMyAPI = async () => {
      let fechaInicial = new Date();
      let fechaPoner = moment(fechaInicial).format("YYYY/MM/DD");

      let email2 = localStorage.getItem("email");
      let idCliente = localStorage.getItem("idCliente");
      let perfil = localStorage.getItem("perfil");
      let response2 = await postJson(
        `${BASE_URL}/serviciosMutuas`,
        {
          email: email2,
        }
      );
      const pueblosObj = response2.pueblos.map((e) => ({ title: e.pueblo }));
      const destinosObj = response2.destinos.map((e) => ({ title: e.destino }));
      const centrosAssistenciaObj = response2.centrosAsistencia.map((e) => ({
        title: e.label,
      }));
      const clientesObj = response2.clientes.map((e) => ({
        id: e.id,
        nombre: e.nombre,
      }));
      // console.log(response2);

      const pacientesObj = response2.pacientes.map((e) => ({
        id: e.id,
        idDireccion: e.idDireccion,
        etiqueta: e.etiqueta,
        nombre: e.nombre,
        pueblo: e.pueblo,
        direccion: e.direccion,
        numTelefono: e.numTelefono,
        nass: e.nass,
        numTelefono2: e.numTelefono2,
        coordenadas: e.coordenadas,
      }));

      // console.log(response2);
      setStateI({
        ...stateI,
        todosDestinos: destinosObj,
        pueblos: pueblosObj,
        turnosLLeida: response2.cap,
        turnosArnau: response2.arnau,
        turnosIgualada: response2.igualada,
        email: email2,
        idCliente: idCliente,
        fechaCompletaEnviar: fechaPoner,
        todosCentros: centrosAssistenciaObj,
        clientes: clientesObj,
        pacientes: pacientesObj,
        perfilLog: perfil,
        idClienteSol: Number(perfil) === 5 ? null : "",
        catalogLoaded: true,
      });
    };

    fetchMyAPI().catch((error) =>
      setStateI((current) => ({
        ...current,
        catalogLoaded: false,
        catalogError: error.message,
      }))
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //Estilos
  const useStyles = makeStyles((theme) => ({
    appBar: {
      position: "relative",
    },
    layout: {
      boxSizing: "border-box",
      width: "auto",
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${drawerWidth + theme.spacing(2) * 2}px)`,
        maxWidth: contentMaxWidth,
        marginLeft: drawerWidth + theme.spacing(2),
        marginRight: theme.spacing(2),
      },
      [theme.breakpoints.up(drawerWidth + theme.spacing(2) * 2 + contentMaxWidth)]: {
        width: contentMaxWidth,
        marginLeft: `calc(${drawerWidth}px + (100vw - ${drawerWidth}px - ${contentMaxWidth}px) / 2)`,
        marginRight: "auto",
      },
    },
    paper: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      padding: theme.spacing(2),
      [theme.breakpoints.up(950 + theme.spacing(3) * 2)]: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
        padding: theme.spacing(3),
      },
    },
    stepper: {
      boxSizing: "border-box",
      width: "100%",
      padding: theme.spacing(3, 0, 5),
      [theme.breakpoints.down("md")]: {
        padding: theme.spacing(2, 0, 3),
      },
    },
    buttons: {
      display: "flex",
      justifyContent: "flex-end",
    },
    button: {
      marginTop: theme.spacing(3),
      marginLeft: theme.spacing(1),
    },
  }));

  const classes = useStyles();

  //Steps
  const steps = [
    "Información del viaje",
    "Primer paciente",
    "Segundo paciente*",
    "Tercer paciente*",
    "Cuarto paciente*",
    // "Quinto paciente*",
    // "Sexto paciente*",
    "Confirma tu viaje",
  ];

  //step counter
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <ViajeDetalles
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            handleData={handleData}
            handleDataDireccion={handleDataDireccion}
            handleDataCoordenadas={handleDataCoordenadas}
            handleOrigenModificado={handleOrigenModificado}
            handleOrigenM={handleOrigenM}
            handleOrigenModificadoP1={handleOrigenModificadoP1}
            handleOrigenModificadoP2={handleOrigenModificadoP2}
            handleOrigenModificadoP3={handleOrigenModificadoP3}
            handleOrigenModificadoP4={handleOrigenModificadoP4}
            handleDestinoM={handleDestinoM}
            handleDestinoModificadoP1={handleDestinoModificadoP1}
            handleDestinoModificadoP2={handleDestinoModificadoP2}
            handleDestinoModificadoP3={handleDestinoModificadoP3}
            handleDestinoModificadoP4={handleDestinoModificadoP4}
            handleDestinoViaje1={handleDestinoViaje1}
            handleDestinoViaje2={handleDestinoViaje2}
            handleDestinoViaje3={handleDestinoViaje3}
            handleDestinoVueltaModificado={handleDestinoVueltaModificado}
            handleVehiculo={handleVehiculo}
            handleDestino={handleDestinoViaje}
            handleConfirm={handleConfirm}
            handleConfirmTarde={handleConfirmTarde}
            handleCentros={handleCentros}
            activeStep={activeStep}
            handleClientes={Number(perfilLog) === 5 ? handleClientes : null}
            handleUrgente={handleUrgente}
            handleAlta={handleAlta}
            handleIngreso={handleIngreso}
            handleMananaTarde={handleMananaTarde}
            handleDateSelect={handleDateSelect}
            handleDestino1={handleDestino1}
            handleDestino2={handleDestino2}
            handleDestino3={handleDestino3}
            handleRehabilitacion={handleRehabilitacion}
            // handleIndentificadorIda={handleIndentificadorIda}
            // handleIndentificadorVuelta={handleIndentificadorVuelta}
            selectedDates={selectedDates}
          />
        );

      case 1:
        return (
          <PrimerPaciente
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            handleData={handleData}
            handleDataDireccion={handleDataDireccion}
            handleDataCoordenadas={handleDataCoordenadas}
            handlePueblo1={handlePueblo1}
            activeStep={activeStep}
            handlePacientes={handlePacientes1}
          />
        );

      case 2:
        return (
          <SegundoPaciente
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            handleData={handleData}
            handleDataDireccion={handleDataDireccion}
            handleDataCoordenadas={handleDataCoordenadas}
            handlePueblo={handlePueblo2}
            activeStep={activeStep}
            handlePacientes={handlePacientes2}
          />
        );
      case 3:
        return (
          <TercerPaciente
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            handleData={handleData}
            handleDataDireccion={handleDataDireccion}
            handleDataCoordenadas={handleDataCoordenadas}
            handlePueblo={handlePueblo3}
            activeStep={activeStep}
            handlePacientes={handlePacientes3}
          />
        );
      case 4:
        return (
          <CuartoPaciente
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            handleData={handleData}
            handleDataDireccion={handleDataDireccion}
            handleDataCoordenadas={handleDataCoordenadas}
            handlePueblo={handlePueblo4}
            activeStep={activeStep}
            handlePacientes={handlePacientes4}
          />
        );
      // case 5:
      //   return (
      //     <QuintoPaciente
      //       nextStep={nextStep}
      //       prevStep={prevStep}
      //       values={values}
      //       handleData={handleData}
      //       handleDataDireccion={handleDataDireccion}
      //       handleDataCoordenadas={handleDataCoordenadas}
      //       handlePueblo={handlePueblo5}
      //       activeStep={activeStep}
      //       handlePacientes={handlePacientes5}
      //     />
      //   );
      // case 6:
      //   return (
      //     <SextoPaciente
      //       nextStep={nextStep}
      //       prevStep={prevStep}
      //       values={values}
      //       handleData={handleData}
      //       handleDataDireccion={handleDataDireccion}
      //       handleDataCoordenadas={handleDataCoordenadas}
      //       handlePueblo={handlePueblo6}
      //       activeStep={activeStep}
      //       handlePacientes={handlePacientes6}
      //     />
      //   );

      case 5:
        return (
          <Confirmacion
            nextStep={nextStep}
            prevStep={prevStep}
            values={values}
            activeStep={activeStep}
          />
        );

      case 6:
        return <LoadingServicio values={values} />;

      default:
        break;
    }
  }

  //Estado global
  const [stateI, setStateI] = useState({
    catalogLoaded: false,
    catalogError: "",
    step: 0,
    tipo: "TURISME",
    destino: {},
    direccionDestino: "",
    direccionHospital: "",
    sesiones: 1,
    fecha: new Date(),
    hora: new Date(),
    fechaCompletaEnviar: "",
    fechaString: "",
    horaString: "",
    fechaMostrar: "Aún no seleccionas fecha",
    fechaTarde: new Date(),
    horaTarde: new Date(),
    fechaCompletaEnviarTarde: "",
    fechaStringTarde: "",
    horaStringTarde: "",
    fechaMostrarTarde: "Aún no seleccionas fecha",

    primerPaciente: "",
    puebloPrimerPaciente: {},
    telfPrimerPaciente: "",
    telfPrimerPaciente2: "",
    direccionPrimerPaciente: "",
    NASS1: "",

    segundoPaciente: "",
    puebloSegundoPaciente: {},
    telfSegundoPaciente: "",
    telfSegundoPaciente2: "",
    direccionSegundoPaciente: "",
    NASS2: "",

    tercerPaciente: "",
    puebloTercerPaciente: {},
    telfTercerPaciente: "",
    telfTercerPaciente2: "",
    direccionTercerPaciente: "",
    NASS3: "",

    cuartoPaciente: "",
    puebloCuartoPaciente: {},
    telfCuartoPaciente: "",
    telfCuartoPaciente2: "",
    direccionCuartoPaciente: "",
    NASS4: "",

    quintoPaciente: "",
    puebloQuintoPaciente: {},
    telfQuintoPaciente: "",
    telfQuintoPaciente2: "",
    direccionQuintoPaciente: "",
    NASS5: "",

    sextoPaciente: "",
    puebloSextoPaciente: {},
    telfSextoPaciente: "",
    telfSextoPaciente2: "",
    direccionSextoPaciente: "",
    NASS6: "",

    email: "",
    idCliente: "",
    pueblos: [],
    todosDestinos: [],
    todosCentros: [],
    clientes: [],
    pacientes: [],
    idPaciente: "",
    idDireccionPaciente1: null,
    idPaciente2: "",
    idDireccionPaciente2: null,
    idPaciente3: "",
    idDireccionPaciente3: null,
    idPaciente4: "",
    idDireccionPaciente4: null,
    idPaciente5: "",
    idDireccionPaciente5: null,
    idPaciente6: "",
    idDireccionPaciente6: null,
    identificadorIda: "",
    identificadorVuelta: "",
    idClienteSol: null,
    perfilLog: null,
    urgente: false,
    mananaTarde: false,
    coordenadasP1: "",
    coordenadasP2: "",
    coordenadasP3: "",
    coordenadasP4: "",
    coordenadasP5: "",
    coordenadasP6: "",
    coordenadasDestino: "",
    vacioAlta: false,
    origenModificado: false,
    vacioVuelta: false,
    origenModificadoP1: false,
    origenModificadoP2: false,
    origenModificadoP3: false,
    origenModificadoP4: false,
    destinoModificado: false,
    destinoModificadoP1: false,
    destinoModificadoP2: false,
    destinoModificadoP3: false,
    destinoModificadoP4: false,
    destino1: false,
    destino1Destino: "",
    destino1direccionDestino: "",
    destino1coordenadasDestino: "",
    destino2: false,
    destino2Destino: "",
    destino2direccionDestino: "",
    destino2coordenadasDestino: "",
    destino3: false,
    destino3Destino: "",
    destino3direccionDestino: "",
    destino3coordenadasDestino: "",
    destinoModificadoVuelta: "",
    direccionModificadoVuelta: "",
    coordenadasdestinoModificadoVuelta: "",
    origenPuebloModificado: "",
    origenDireccionModificada: "",
    origenCoordenadaModificada: "",
    rehabilitacion: false,
  });
  const [selectedDates, setSelectedDates] = useState([]);

  const [activeStep, setActiveStep] = React.useState(0);

  const nextStep = () => {
    // console.log(stateI);
    if (
      Number(activeStep) === 0 &&
      (stateI.tipo === "" ||
        stateI.destino.title === "" ||
        (!stateI.vacioAlta && Object.keys(stateI.destino).length === 0) ||
        (!stateI.vacioAlta && stateI.coordenadasDestino === "") ||
        Number(stateI.sesiones) === 0 ||
        stateI.horaString === "" ||
        stateI.direccionHospital === "" ||
        stateI.fechaCompletaEnviar === "" ||
        stateI.identificadorIda === "" ||
        stateI.idClienteSol === null ||
        (stateI.destinoModificado &&
          (!stateI.coordenadasdestinoModificadoVuelta ||
            stateI.coordenadasdestinoModificadoVuelta === "" ||
            !stateI.destinoModificadoP1)) ||
        (stateI.origenModificado &&
          (!stateI.origenCoordenadaModificada ||
            stateI.origenCoordenadaModificada === "" ||
            (!stateI.vacioAlta && !stateI.origenModificadoP1))))
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Llena todos los datos por favor",
      });
    } else if (
      Number(activeStep) === 1 &&
      (stateI.NASS1 === "" ||
        stateI.primerPaciente === "" ||
        (typeof stateI.puebloPrimerPaciente == "object" &&
          Object.keys(stateI.puebloPrimerPaciente).length === 0) ||
        stateI.coordenadasP1 === "")
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Llena todos los datos por favor",
      });
    } else {
      const { step } = stateI;
      setStateI({
        ...stateI,
        step: step + 1,
      });
      setActiveStep(step + 1);
    }
  };

  const prevStep = () => {
    const { step } = stateI;
    setStateI({
      ...stateI,
      step: step - 1,
    });
    setActiveStep(step - 1);
  };
  //handle fecha
  const handleConfirm = (date, tipo) => {
    //Dia semana
    // let dia = moment(date).day();
    // console.warn("El dia de la semana es: " + dia);
    // console.warn("A date has been picked: ", date);
    //Fecha elegida
    const diaNum = date.getDate();
    const mesNum = date.getMonth() + 1;
    const yearNum = date.getFullYear();
    const horasNum = date.getHours();
    const minutos = date.getMinutes();
    //Fecha actual
    let today = new Date();
    // let dd = today.getDate();
    // let mm = String(today.getMonth() + 1);
    // let yyyy = today.getFullYear();

    let todayFecha = moment().day();
    let fechaE = moment(date).day();

    if (tipo === "Fecha") {
      if (date >= today || todayFecha === fechaE) {
        let pruebaFecha = `${yearNum}-${mesNum}-${diaNum}`;
        // let fechaMostrar = pruebaFecha.split(" ");
        // let diasn = fechaMostrar[0].split("-");
        let fechaInput = `El ${moment(date).format("DD/MM/YYYY")}, falta hora`;

        setStateI({
          ...stateI,
          fecha: date,
          fechaMostrar: fechaInput,
          fechaCompletaEnviar: pruebaFecha,
          horaString: "",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No puedes elegir una fecha pasada, escoge una correcta por favor",
        });
      }
    } else {
      let horaCompleta = `${horasNum}:${minutos}:00`;
      let fechaInput = `El ${moment(values.fecha).format(
        "DD/MM/YYYY"
      )} a las ${moment(date).format("HH:mm")}`;

      setStateI({
        ...stateI,
        hora: date,
        fechaCompletaEnviar: `${moment(stateI.fecha).format(
          "YYYY-MM-DD"
        )} ${horaCompleta}`,
        fechaMostrar: fechaInput,
        horaString: horaCompleta,
      });
    }
  };
  const handleConfirmTarde = (date, tipo) => {
    //Dia semana
    // let dia = moment(date).day();
    // console.warn("El dia de la semana es: " + dia);
    // console.warn("A date has been picked: ", date);
    //Fecha elegida
    const diaNum = date.getDate();
    const mesNum = date.getMonth() + 1;
    const yearNum = date.getFullYear();
    const horasNum = date.getHours();
    const minutos = date.getMinutes();
    //Fecha actual
    let today = new Date();
    // let dd = today.getDate();
    // let mm = String(today.getMonth() + 1);
    // let yyyy = today.getFullYear();

    let todayFecha = moment().day();
    let fechaE = moment(date).day();

    if (tipo === "Fecha") {
      if (date >= today || todayFecha === fechaE) {
        let pruebaFecha = `${yearNum}-${mesNum}-${diaNum}`;
        // let fechaMostrar = pruebaFecha.split(" ");
        // let diasn = fechaMostrar[0].split("-");
        let fechaInput = `El ${moment(date).format("DD/MM/YYYY")}, falta hora`;

        setStateI({
          ...stateI,
          fechaTarde: date,
          fechaMostrarTarde: fechaInput,
          fechaCompletaEnviarTarde: pruebaFecha,
          horaStringTarde: "",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No puedes elegir una fecha pasada, escoge una correcta por favor",
        });
      }
    } else {
      let horaCompleta = `${horasNum}:${minutos}:00`;
      let fechaInput = `El ${moment(values.fecha).format(
        "DD/MM/YYYY"
      )} a las ${moment(date).format("HH:mm")}`;

      setStateI({
        ...stateI,
        horaTarde: date,
        fechaCompletaEnviarTarde: `${moment(stateI.fecha).format(
          "YYYY-MM-DD"
        )} ${horaCompleta}`,
        fechaMostrarTarde: fechaInput,
        horaStringTarde: horaCompleta,
      });
    }
  };
  const handleDateSelect = (date) => {
    if (date !== null) {
      if (date instanceof Date) {
        const formattedDate = format(date, "yyyy-MM-dd");

        setSelectedDates((prevDates) => {
          if (prevDates.includes(formattedDate)) {
            return prevDates.filter((d) => d !== formattedDate);
          } else {
            return [...prevDates, formattedDate];
          }
        });
      } else {
      }
    }
  };
  const handleVehiculo = (value) => {
    setStateI({
      ...stateI,
      tipo: value,
    });
  };
  const handlePueblo1 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        puebloPrimerPaciente: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        puebloPrimerPaciente: value,
      });
    } else {
      setStateI({
        ...stateI,
        puebloPrimerPaciente: { title: value },
      });
    }
  };
  const handlePueblo2 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        puebloSegundoPaciente: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        puebloSegundoPaciente: value,
      });
    } else {
      setStateI({
        ...stateI,
        puebloSegundoPaciente: { title: value },
      });
    }
  };
  const handlePueblo3 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        puebloTercerPaciente: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        puebloTercerPaciente: value,
      });
    } else {
      setStateI({
        ...stateI,
        puebloTercerPaciente: { title: value },
      });
    }
  };
  const handlePueblo4 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        puebloCuartoPaciente: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        puebloCuartoPaciente: value,
      });
    } else {
      setStateI({
        ...stateI,
        puebloCuartoPaciente: { title: value },
      });
    }
  };
  const handleDestinoViaje = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        destiono: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        destino: value,
      });
    } else {
      setStateI({
        ...stateI,
        destino: { title: value },
      });
    }
  };
  const handleCentros = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        direccionHospital: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        direccionHospital: value,
      });
    } else {
      setStateI({
        ...stateI,
        direccionHospital: { title: value },
      });
    }
  };
  const handleData = (input) => (e) => {
    // const value = e?.target?.value || e; // Si `e` no tiene `target.value`, toma `e` directamente
    setStateI((prevState) => ({
      ...prevState,
      [input]: e?.target?.value,
    }));
  };
  const handleOrigenModificado = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        origenPuebloModificado: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        origenPuebloModificado: value,
      });
    } else {
      setStateI({
        ...stateI,
        origenPuebloModificado: { title: value },
      });
    }
  };
  const handleDestinoViaje1 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        destino1Destino: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        destino1Destino: value,
      });
    } else {
      setStateI({
        ...stateI,
        destino1Destino: { title: value },
      });
    }
  };
  const handleDestinoViaje2 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        destino2Destino: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        destino2Destino: value,
      });
    } else {
      setStateI({
        ...stateI,
        destino2Destino: { title: value },
      });
    }
  };
  const handleDestinoViaje3 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        destino3Destino: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        destino3Destino: value,
      });
    } else {
      setStateI({
        ...stateI,
        destino3Destino: { title: value },
      });
    }
  };
  const handleDestinoVueltaModificado = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        destinoModificadoVuelta: {},
      });
    } else if (value.title !== undefined) {
      setStateI({
        ...stateI,
        destinoModificadoVuelta: value,
      });
    } else {
      setStateI({
        ...stateI,
        destinoModificadoVuelta: { title: value },
      });
    }
  };
  const handleDataCoordenadas = (input) => (e) => {
    const value = e?.target?.value || e; // Si `e` no tiene `target.value`, toma `e` directamente
    setStateI((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };
  const handleDataDireccion = (input) => (event) => {
    const value = event?.target ? event.target.value : event;
    const coords = { direccionPrimerPaciente: "coordenadasP1", direccionSegundoPaciente: "coordenadasP2", direccionTercerPaciente: "coordenadasP3", direccionCuartoPaciente: "coordenadasP4" };
    setStateI((current) => ({ ...current, [input]: value, ...(coords[input] && current[input] !== value ? { [coords[input]]: "" } : {}) }));
  };
  const handleClientes = (value) => {
    setStateI((current) => ({ ...current, idClienteSol: value || null, pacientes: [], idPaciente: "", idPaciente2: "", idPaciente3: "", idPaciente4: "", primerPaciente: "", segundoPaciente: "", tercerPaciente: "", cuartoPaciente: "" }));
    if (!value?.id) return;
    postJson(`${BASE_URL}/pacientes/opciones`, { idCliente: value.id }).then((result) => {
      setStateI((current) => current.idClienteSol?.id === value.id ? { ...current, pacientes: result.pacientes } : current);
    }).catch((error) => setStateI((current) => ({ ...current, catalogError: error.message, catalogLoaded: false })));
  };
  const handlePacientes1 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        idPaciente: "",
        idDireccionPaciente1: null,
        primerPaciente: "",
        puebloPrimerPaciente: {},
        telfPrimerPaciente: "",
        direccionPrimerPaciente: "",
        NASS1: "",
        telfPrimerPaciente2: "",
        coordenadasP1: "",
      });
    } else if (value !== undefined) {
      setStateI({
        ...stateI,
        idPaciente: value.id,
        idDireccionPaciente1: value.idDireccion || null,
        primerPaciente: value.nombre,
        puebloPrimerPaciente: { title: value.pueblo },
        telfPrimerPaciente: value.numTelefono,
        direccionPrimerPaciente: value.direccion,
        NASS1: value.nass,
        telfPrimerPaciente2: value.numTelefono2,
        coordenadasP1: value.coordenadas,
      });
    } else {
      setStateI({
        ...stateI,
        idPaciente: value.id,
        idDireccionPaciente1: value.idDireccion || null,
        primerPaciente: value.nombre,
        puebloPrimerPaciente: { title: value.pueblo },
        telfPrimerPaciente: value.numTelefono,
        direccionPrimerPaciente: value.direccion,
        NASS1: value.nass,
        telfPrimerPaciente2: value.numTelefono2,
        coordenadasP1: value.coordenadas,
      });
    }
  };
  const handlePacientes2 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        idPaciente2: "",
        idDireccionPaciente2: null,
        segundoPaciente: "",
        puebloSegundoPaciente: {},
        telfSegundoPaciente: "",
        direccionSegundoPaciente: "",
        NASS2: "",
        telfSegundoPaciente2: "",
        coordenadasP2: "",
      });
    } else if (value !== undefined) {
      setStateI({
        ...stateI,
        idPaciente2: value.id,
        idDireccionPaciente2: value.idDireccion || null,
        segundoPaciente: value.nombre,
        puebloSegundoPaciente: { title: value.pueblo },
        telfSegundoPaciente: value.numTelefono,
        direccionSegundoPaciente: value.direccion,
        NASS2: value.nass,
        telfSegundoPaciente2: value.numTelefono2,
        coordenadasP2: value.coordenadas,
      });
    } else {
      setStateI({
        ...stateI,
        idPaciente2: value.id,
        idDireccionPaciente2: value.idDireccion || null,
        segundoPaciente: value.nombre,
        puebloSegundoPaciente: { title: value.pueblo },
        telfSegundoPaciente: value.numTelefono,
        direccionSegundoPaciente: value.direccion,
        NASS2: value.nass,
        telfSegundoPaciente2: value.numTelefono2,
        coordenadasP2: value.coordenadas,
      });
    }
  };
  const handlePacientes3 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        idPaciente3: "",
        idDireccionPaciente3: null,
        tercerPaciente: "",
        puebloTercerPaciente: {},
        telfTercerPaciente: "",
        direccionTercerPaciente: "",
        NASS3: "",
        telfTercerPaciente2: "",
        coordenadasP3: "",
      });
    } else if (value !== undefined) {
      setStateI({
        ...stateI,
        idPaciente3: value.id,
        idDireccionPaciente3: value.idDireccion || null,
        tercerPaciente: value.nombre,
        puebloTercerPaciente: { title: value.pueblo },
        telfTercerPaciente: value.numTelefono,
        direccionTercerPaciente: value.direccion,
        NASS3: value.nass,
        telfTercerPaciente2: value.numTelefono2,
        coordenadasP3: value.coordenadas,
      });
    } else {
      setStateI({
        ...stateI,
        idPaciente3: value.id,
        idDireccionPaciente3: value.idDireccion || null,
        tercerPaciente: value.nombre,
        puebloTercerPaciente: { title: value.pueblo },
        telfTercerPaciente: value.numTelefono,
        direccionTercerPaciente: value.direccion,
        NASS3: value.nass,
        telfTercerPaciente2: value.numTelefono2,
        coordenadasP3: value.coordenadas,
      });
    }
  };
  const handlePacientes4 = (value) => {
    if (value == null) {
      setStateI({
        ...stateI,
        idPaciente4: "",
        idDireccionPaciente4: null,
        cuartoPaciente: "",
        puebloCuartoPaciente: {},
        telfCuartoPaciente: "",
        direccionCuartoPaciente: "",
        NASS4: "",
        telfCuartoPaciente2: "",
        coordenadasP4: "",
      });
    } else if (value !== undefined) {
      setStateI({
        ...stateI,
        idPaciente4: value.id,
        idDireccionPaciente4: value.idDireccion || null,
        cuartoPaciente: value.nombre,
        puebloCuartoPaciente: { title: value.pueblo },
        telfCuartoPaciente: value.numTelefono,
        direccionCuartoPaciente: value.direccion,
        NASS4: value.nass,
        telfCuartoPaciente2: value.numTelefono2,
        coordenadasP4: value.coordenadas,
      });
    } else {
      setStateI({
        ...stateI,
        idPaciente4: value.id,
        idDireccionPaciente4: value.idDireccion || null,
        cuartoPaciente: value.nombre,
        puebloCuartoPaciente: { title: value.pueblo },
        telfCuartoPaciente: value.numTelefono,
        direccionCuartoPaciente: value.direccion,
        NASS4: value.nass,
        telfCuartoPaciente2: value.numTelefono2,
        coordenadasP4: value.coordenadas,
      });
    }
  };
  const handleUrgente = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        urgente: value,
      });
    }
  };
  const handleAlta = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        vacioAlta: value,
        origenModificado: value,
      });
    }
  };
  const handleIngreso = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        vacioVuelta: value,
      });
    }
  };
  const handleOrigenM = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        origenModificado: value,
      });
    }
  };
  const handleOrigenModificadoP1 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        origenModificadoP1: value,
      });
    }
  };
  const handleOrigenModificadoP2 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        origenModificadoP2: value,
      });
    }
  };
  const handleOrigenModificadoP3 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        origenModificadoP3: value,
      });
    }
  };
  const handleOrigenModificadoP4 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        origenModificadoP4: value,
      });
    }
  };
  const handleDestinoM = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        destinoModificado: value,
      });
    }
  };
  const handleDestinoModificadoP1 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        destinoModificadoP1: value,
      });
    }
  };
  const handleDestinoModificadoP2 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        destinoModificadoP2: value,
      });
    }
  };
  const handleDestinoModificadoP3 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        destinoModificadoP3: value,
      });
    }
  };
  const handleDestinoModificadoP4 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        destinoModificadoP4: value,
      });
    }
  };
  const handleRehabilitacion = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        rehabilitacion: value,
      });
    }
  };
  const handleMananaTarde = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        mananaTarde: value,
      });
    }
  };
  const handleDestino1 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        destino1: value,
      });
    }
  };
  const handleDestino2 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        destino2: value,
      });
    }
  };
  const handleDestino3 = (value) => {
    if (value != null) {
      setStateI({
        ...stateI,
        destino3: value,
      });
    }
  };
  //Handle fields on change
  const {
    step,
    tipo,
    destino,
    direccionHospital,
    sesiones,
    fecha,
    hora,
    fechaCompletaEnviar,
    fechaString,
    horaString,
    fechaMostrar,
    fechaTarde,
    horaTarde,
    fechaCompletaEnviarTarde,
    fechaStringTarde,
    horaStringTarde,
    fechaMostrarTarde,

    primerPaciente,
    puebloPrimerPaciente,
    telfPrimerPaciente,
    telfPrimerPaciente2,
    direccionPrimerPaciente,
    NASS1,

    segundoPaciente,
    puebloSegundoPaciente,
    telfSegundoPaciente,
    telfSegundoPaciente2,
    direccionSegundoPaciente,
    NASS2,

    tercerPaciente,
    puebloTercerPaciente,
    telfTercerPaciente,
    telfTercerPaciente2,
    direccionTercerPaciente,
    NASS3,

    cuartoPaciente,
    puebloCuartoPaciente,
    telfCuartoPaciente,
    telfCuartoPaciente2,
    direccionCuartoPaciente,
    NASS4,

    quintoPaciente,
    puebloQuintoPaciente,
    telfQuintoPaciente,
    telfQuintoPaciente2,
    direccionQuintoPaciente,
    NASS5,

    sextoPaciente,
    puebloSextoPaciente,
    telfSextoPaciente,
    telfSextoPaciente2,
    direccionSextoPaciente,
    NASS6,

    email,
    idCliente,
    pueblos,
    todosDestinos,
    todosCentros,
    clientes,
    idClienteSol,
    perfilLog,
    pacientes,
    idPaciente,
    idDireccionPaciente1,
    idPaciente2,
    idDireccionPaciente2,
    idPaciente3,
    idDireccionPaciente3,
    idPaciente4,
    idDireccionPaciente4,
    idPaciente5,
    idDireccionPaciente5,
    idPaciente6,
    idDireccionPaciente6,
    urgente,
    mananaTarde,
    identificadorIda,
    identificadorVuelta,
    direccionDestino,
    coordenadasP1,
    coordenadasP2,
    coordenadasP3,
    coordenadasP4,
    coordenadasP5,
    coordenadasP6,
    coordenadasDestino,
    vacioAlta,
    origenModificado,
    vacioVuelta,
    origenModificadoP1,
    origenModificadoP2,
    origenModificadoP3,
    origenModificadoP4,
    destinoModificado,
    destinoModificadoP1,
    destinoModificadoP2,
    destinoModificadoP3,
    destinoModificadoP4,
    destino1,
    destino1Destino,
    destino1direccionDestino,
    destino1coordenadasDestino,
    destino2,
    destino2Destino,
    destino2direccionDestino,
    destino2coordenadasDestino,
    destino3,
    destino3Destino,
    destino3direccionDestino,
    destino3coordenadasDestino,
    destinoModificadoVuelta,
    direccionModificadoVuelta,
    coordenadasdestinoModificadoVuelta,
    origenPuebloModificado,
    origenDireccionModificada,
    origenCoordenadaModificada,
    rehabilitacion,
  } = stateI;

  const values = {
    step,
    tipo,
    destino,
    sesiones,
    direccionHospital,
    fecha,
    hora,
    fechaCompletaEnviar,
    fechaString,
    horaString,
    fechaMostrar,
    fechaTarde,
    horaTarde,
    fechaCompletaEnviarTarde,
    fechaStringTarde,
    horaStringTarde,
    fechaMostrarTarde,

    primerPaciente,
    puebloPrimerPaciente,
    telfPrimerPaciente,
    telfPrimerPaciente2,
    direccionPrimerPaciente,
    NASS1,

    segundoPaciente,
    puebloSegundoPaciente,
    telfSegundoPaciente,
    telfSegundoPaciente2,
    direccionSegundoPaciente,
    NASS2,

    tercerPaciente,
    puebloTercerPaciente,
    telfTercerPaciente,
    telfTercerPaciente2,
    direccionTercerPaciente,
    NASS3,

    cuartoPaciente,
    puebloCuartoPaciente,
    telfCuartoPaciente,
    telfCuartoPaciente2,
    direccionCuartoPaciente,
    NASS4,

    quintoPaciente,
    puebloQuintoPaciente,
    telfQuintoPaciente,
    telfQuintoPaciente2,
    direccionQuintoPaciente,
    NASS5,

    sextoPaciente,
    puebloSextoPaciente,
    telfSextoPaciente,
    telfSextoPaciente2,
    direccionSextoPaciente,
    NASS6,

    email,
    idCliente,
    pueblos,

    todosDestinos,
    todosCentros,
    clientes,
    idClienteSol,
    perfilLog,
    pacientes,
    idPaciente,
    idDireccionPaciente1,
    idPaciente2,
    idDireccionPaciente2,
    idPaciente3,
    idDireccionPaciente3,
    idPaciente4,
    idDireccionPaciente4,
    idPaciente5,
    idDireccionPaciente5,
    idPaciente6,
    idDireccionPaciente6,
    urgente,
    mananaTarde,
    identificadorIda,
    identificadorVuelta,
    direccionDestino,
    coordenadasP1,
    coordenadasP2,
    coordenadasP3,
    coordenadasP4,
    coordenadasP5,
    coordenadasP6,
    coordenadasDestino,
    vacioAlta,
    origenModificado,
    vacioVuelta,

    origenModificadoP1,
    origenModificadoP2,
    origenModificadoP3,
    origenModificadoP4,

    destinoModificado,
    destinoModificadoP1,
    destinoModificadoP2,
    destinoModificadoP3,
    destinoModificadoP4,
    destino1,
    destino1Destino,
    destino1direccionDestino,
    destino1coordenadasDestino,
    destino2,
    destino2Destino,
    destino2direccionDestino,
    destino2coordenadasDestino,
    destino3,
    destino3Destino,
    destino3direccionDestino,
    destino3coordenadasDestino,

    destinoModificadoVuelta,
    direccionModificadoVuelta,
    coordenadasdestinoModificadoVuelta,
    origenPuebloModificado,
    origenDireccionModificada,
    origenCoordenadaModificada,
    rehabilitacion,
  };

  if (!stateI.catalogLoaded) {
    return stateI.catalogError ? (
      <main className={classes.layout}>
        <Error message={stateI.catalogError} />
      </main>
    ) : (
      <main className={classes.layout}>
        <LinearProgress aria-label="Cargando datos del servicio de mutuas" />
      </main>
    );
  }

  return (
    <React.Fragment>
      <CssBaseline />
      <AppBar position="fixed" color="default" className={classes.appBar}>
        <Toolbar>
          <Link component={RouterLink} to="/" color="inherit">
            <IconButton edge="start" aria-label="menu">
              <ArrowBackIcon color="inherit" />
            </IconButton>
          </Link>
          <Typography variant="h6" color="inherit" noWrap>
            Pedir servició de Mutuas
          </Typography>
        </Toolbar>
      </AppBar>
      <main className={classes.layout}>
        <Box borderRadius={16} borderColor="primary.main" {...defaultProps}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              Pedir servició de Mutuas
            </Typography>
            <Stepper
              activeStep={activeStep}
              orientation={isCompact ? "vertical" : "horizontal"}
              className={classes.stepper}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
            <React.Fragment>
              <React.Fragment>{getStepContent(activeStep)}</React.Fragment>
            </React.Fragment>
          </Paper>
        </Box>
      </main>
    </React.Fragment>
  );
}
